<div class="form" [formGroup]="form">
  <ifc-google-places-autocomplete-form-field
    [control]="form.get('line1')"
    fieldType="street"
    cssClass="form__field"
    (placeSelected)="handleStreetAddressChange($event)">
  </ifc-google-places-autocomplete-form-field>

    <mat-form-field class="form__field" appearance="outline">
      <mat-label>Unit/Suite/Apt #</mat-label>
      <input matInput formControlName="line2" />
      <mat-error *ngIf="form.get('line2')?.errors | hasControlError: ['maxlength']">
        Unit/Suite/Apt # is too long.
      </mat-error>
    </mat-form-field>

    <div class="form__row">
      <ifc-google-places-autocomplete-form-field
        [control]="form.get('city')"
        fieldType="city"
        cssClass="form__field form__field--city"
        (placeSelected)="handleCityAddressChange($event)">
      </ifc-google-places-autocomplete-form-field>

    <mat-form-field class="form__field form__field--state" appearance="outline">
      <mat-label>State</mat-label>
      <mat-select formControlName="state">
        <mat-option *ngFor="let state of states" [value]="state.value">
          {{ state.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('state')?.errors | hasControlError: ['required']">State is required.</mat-error>
    </mat-form-field>

    <mat-form-field class="form__field form__field--zip" appearance="outline">
      <mat-label>Zip</mat-label>
      <input matInput formControlName="zip" mask="00000" />
      <mat-error *ngIf="form.get('zip')?.errors | hasControlError: ['required']">Zip code is required.</mat-error>
      <mat-error *ngIf="form.get('zip')?.errors | hasControlError: ['pattern']">
        Please enter a valid zip code.
      </mat-error>
      </mat-form-field>
    </div>
</div>
